import { Checkbox, FormControlLabel, type CheckboxProps } from '@mui/material';

export type HFCheckboxProps = Omit<CheckboxProps, 'onChange'> & {
  label: string;
  onChange?: (checked: boolean) => void;
};

export function HFCheckbox({ label, checked, onChange, ...props }: HFCheckboxProps) {
  return (
    <FormControlLabel control={<Checkbox checked={checked} onChange={(event) => onChange?.(event.target.checked)} {...props} />} label={label} />
  );
}
